










import { Vue, Component, Prop } from 'vue-property-decorator';
import store from './store';
import VueI18n from 'vue-i18n';
import i18n from './i18n';

import { Locale } from '@/enums/Locale';
import { Store } from '@/enums/Store';

import { ClientFactory } from '@/util/api.ts';

import { namespace } from 'vuex-class';
import { Init, InitPayload } from '@/store/app';

import { extend } from 'vee-validate';
import { required, min } from 'vee-validate/dist/rules';

import Error from '@/components/Error.vue';
import EventSelection from '@/components/Event/EventSelection.vue';
import StepWrapper from '@/components/StepWrapper.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SuccessPage from '@/components/SuccessPage.vue';

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueI18n);

const APP = namespace(Store.APP);

Vue.prototype.$api = ClientFactory.createApiClient();

@Component({
  components: { SuccessPage, StepWrapper, EventSelection, Error },
  store,
  i18n,
})
export default class App extends Vue {
  @Prop() url?: string;
  @Prop() locale?: Locale;
  @Prop() promoter?: number;
  @Prop() store?: number;
  @Prop() currency?: string;
  @Prop() showinactive?: string;

  @APP.Getter('isOnStepWrapper') isOnStepWrapper!: boolean;
  @APP.Getter('isOnEventSelection') isOnEventSelection!: boolean;
  @APP.Getter('isOnSuccessStep') isOnSuccessStep!: boolean;
  @APP.Action('init') init!: Init;
  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void;
  @APP.Mutation('CLEAR_ERRORS') clearErrors!: () => void;

  created(): void {
    this.clearErrors();

    extend('required', {
      ...required,
      message: this.$t('field-required').toString(),
    });

    extend('min', {
      ...min,
      message: this.$t('length-invalid').toString(),
    });

    if (this.url) {
      this.$api.url = this.url;
    }

    this.init(new InitPayload(this.locale, this.promoter, this.store, this.currency, this.showinactive));

    if (this.locale) {
      this.$i18n.locale = this.locale;
    }
  }
}
